import { Relative, TextSkeleton, VStack } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { ChatMessageLoading } from 'components'

export const DebugMessagesLoading: FC = () => {
  return (
    <Relative height="100%">
      <VStack height="100%" p="s-16" space="s-16" align="center">
        <TextSkeleton width={120} height={18} />
        <ChatMessageLoading placement="right" chatHeight={72} />
        <ChatMessageLoading chatHeight={216} />
        <ChatMessageLoading placement="right" chatWidth={420} />
        <ChatMessageLoading chatHeight={144} />
        <TextSkeleton width={120} height={18} />
        <ChatMessageLoading placement="right" chatWidth={200} />
        <ChatMessageLoading chatWidth={360} />
      </VStack>
    </Relative>
  )
}
